<script setup>
import {useGlobalLoaderStore} from '../stores/globalLoader'
import {storeToRefs} from 'pinia'

const globalLoaderStore = useGlobalLoaderStore()
const {loading, textContent} = storeToRefs(globalLoaderStore)
</script>

<template>
    <div v-if="loading" class="global-loader-container">
        <div class="global-loader">
            <div class="spinner"></div>
            <p class="loading-text">{{ textContent }}</p>
        </div>
    </div>
</template>

<style scoped>
.global-loader-container {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
}

.global-loader {
    background-color: white;
    border-radius: 8px;
    padding: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.spinner {
    width: 50px;
    height: 50px;
    border: 5px solid #f3f3f3;
    border-top: 5px solid #3498db;
    border-radius: 50%;
    animation: spin 1s linear infinite;
    margin-bottom: 10px;
}

.loading-text {
    color: #333;
    font-size: 16px;
    margin: 0;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}
</style>
